$( document ).ready(function() {
  //goTo(window.location.hash)
//   function goTo(listId) {
  	
//     if(listId) {
//       var topH = $(listId).parent().offset().top - ($("#shopify-section-static-header").height())
//       $('html, body').animate({ scrollTop: topH });
//          $(listId).siblings().trigger('click');
//     }
//   }
  
//   $(".navmenu-link").click(function(e){
//   	goTo("#"+ $(this).attr("href").split("#")[1])
//   })
  
    
  
  $('.navmenu-id-primary').find('.navmenu-id-teacher-resources').find('ul li a').each(function(){
    $(this).attr('href', '/pages/primary-teacher-resources#'+$(this).text().toLowerCase().trim().replace(/\s+/g, "-")); 
    if($(this).text().replace(/\s+/g, "")=="Springboard"){
     $(this).attr('href', '/pages/primary-teacher-resources#springboard-foundation'); 
    }
  });
  
//   for inline menu
  
  $(".inpage-menu a").click(function(){
  	goToLink($(this).attr("href"))
  })
   
   
   function goToLink(listId) {
     var height=0;
     var flag =false;
     $('#accordion li').find('span').each(function(){
       if($(this).hasClass('active')){
       	flag=true;
         height= $(this).closest('li').height();
       }
     })
     
     
   	var topH = $(listId).parent().offset().top - ($("#shopify-section-static-header").height())
    if(flag){
      console.log("true")
    $('html, body').animate({ scrollTop: topH -height-40});
    }
     else{
     $('html, body').animate({ scrollTop: topH +20});
     }
    if($(listId).siblings().is(':hidden')){
       	$(listId).click();
       }
   	 }
    
});